import { render, staticRenderFns } from "./TestForm.vue?vue&type=template&id=7488826a&scoped=true&"
import script from "./TestForm.vue?vue&type=script&lang=js&"
export * from "./TestForm.vue?vue&type=script&lang=js&"
import style0 from "./TestForm.vue?vue&type=style&index=0&id=7488826a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7488826a",
  null
  
)

export default component.exports